import React from "react";
import "./BusinessInfo.css";

function BusinessInfoCommon({
    business,
    errors,
    handleChange,
    hours,
    minutes,
    meridians,
}) {

    return (

        <>

            <h2>Business Information</h2>

            <p className="business-subtitle">
                Tell us about your business.
            </p>

            {/* =========================
                Business Name
            ========================= */}

            <div className="form-group">

                <label>
                    Business Name
                </label>

                <input
                    type="text"
                    name="businessName"
                    placeholder="Enter Business Name"
                    value={business.businessName || ""}
                    onChange={handleChange}
                />

                {errors.businessName && (
                    <span className="error">
                        {errors.businessName}
                    </span>
                )}

            </div>

            {/* =========================
                Description
            ========================= */}

            <div className="form-group">

                <label>
                    Business Description
                </label>

                <textarea
                    name="description"
                    placeholder="Tell customers about your business..."
                    value={business.description || ""}
                    onChange={handleChange}
                    rows={4}
                />

                {errors.description && (
                    <span className="error">
                        {errors.description}
                    </span>
                )}

            </div>

            {/* =========================
                Opening Time
            ========================= */}

            <div className="form-group">

                <label>
                    Opening Time
                </label>

                <div className="time-container">

                    <select
                        name="openingHour"
                        value={business.openingHour || ""}
                        onChange={handleChange}
                    >
                        <option value="">HH</option>

                        {hours.map(hour => (
                            <option
                                key={hour}
                                value={hour}
                            >
                                {hour}
                            </option>
                        ))}

                    </select>

                    <span>:</span>

                    <select
                        name="openingMinute"
                        value={business.openingMinute || ""}
                        onChange={handleChange}
                    >
                        <option value="">MM</option>

                        {minutes.map(minute => (
                            <option
                                key={minute}
                                value={minute}
                            >
                                {minute}
                            </option>
                        ))}

                    </select>

                    <select
                        name="openingPeriod"
                        value={business.openingPeriod || ""}
                        onChange={handleChange}
                    >
                        <option value="">AM / PM</option>

                        {meridians.map(item => (
                            <option
                                key={item}
                                value={item}
                            >
                                {item}
                            </option>
                        ))}

                    </select>

                </div>

                {errors.openingTime && (
                    <span className="error">
                        {errors.openingTime}
                    </span>
                )}

            </div>

            {/* =========================
                Closing Time
            ========================= */}

            <div className="form-group">

                <label>
                    Closing Time
                </label>

                <div className="time-container">

                    <select
                        name="closingHour"
                        value={business.closingHour || ""}
                        onChange={handleChange}
                    >
                        <option value="">HH</option>

                        {hours.map(hour => (
                            <option
                                key={hour}
                                value={hour}
                            >
                                {hour}
                            </option>
                        ))}

                    </select>

                    <span>:</span>

                    <select
                        name="closingMinute"
                        value={business.closingMinute || ""}
                        onChange={handleChange}
                    >
                        <option value="">MM</option>

                        {minutes.map(minute => (
                            <option
                                key={minute}
                                value={minute}
                            >
                                {minute}
                            </option>
                        ))}

                    </select>

                    <select
                        name="closingPeriod"
                        value={business.closingPeriod || ""}
                        onChange={handleChange}
                    >
                        <option value="">AM / PM</option>

                        {meridians.map(item => (
                            <option
                                key={item}
                                value={item}
                            >
                                {item}
                            </option>
                        ))}

                    </select>

                </div>

                {errors.closingTime && (
                    <span className="error">
                        {errors.closingTime}
                    </span>
                )}

            </div>

            {/* =========================
                Experience
            ========================= */}

            <div className="form-group">

                <label>
                    Years of Experience
                </label>

                <input
                    type="number"
                    name="experience"
                    placeholder="Years of Experience"
                    value={business.experience || ""}
                    onChange={handleChange}
                />

            </div>

        </>

    );

}

export default BusinessInfoCommon;